import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { PublicoAlvoPlanejamentoOficina } from '../../../../core/publico-alvo-planejamento-oficina';

@Component({
    selector: 'listar-publico-alvo-planejamento-oficina',
    templateUrl: './listar-publico-alvo-planejamento-oficina.component.html',
    styleUrls: ['./listar-publico-alvo-planejamento-oficina.component.css']
})
export class ListarPublicosAlvoPlanejamentoOficinaComponent implements OnInit {

    @Output() onAtualizarPublicoAlvoAtividade = new EventEmitter();
    @Output() onAdicionarPublicoAlvoPlanejamentoOficina = new EventEmitter();

    @Input() publicosAlvosPlanejamentoOficina: PublicoAlvoPlanejamentoOficina[];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    mostrarTabela = false;
    msg: string;

    displayedColumns: string[] = ['descricao', 'acoes'];
    dataSource: MatTableDataSource<PublicoAlvoPlanejamentoOficina> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    filteredRequests: MatTableDataSource<PublicoAlvoPlanejamentoOficina> = new MatTableDataSource();
    descricaoFiltered: string;
    dataFiltered: string;

    constructor(private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.dataSource.paginator = this.paginator;
        this.carregarLista();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["publicosAlvosPlanejamentoOficina"] && !_.isEmpty(changes["publicosAlvosPlanejamentoOficina"].currentValue)) {
            this.carregarLista();
        }
    }

    carregarLista() {
        if (_.isEmpty(this.publicosAlvosPlanejamentoOficina)) {
            this.mostrarTabela = false;
            this.msg = 'Nenhum público alvo cadastrado.';
        } else {
            this.dataSource.data = this.publicosAlvosPlanejamentoOficina;
            this.mostrarTabela = true;
        }

        this.filteredRequests = this.dataSource;
    }

    deletar(publicoAlvoAtividade: any): void {
        const index = this.publicosAlvosPlanejamentoOficina.indexOf(this.publicosAlvosPlanejamentoOficina.find(col => col === publicoAlvoAtividade));
        if (index >= 0) {
            this.publicosAlvosPlanejamentoOficina.splice(index, 1);
            this.carregarLista();
        }
    }

    atualizar(publicoAlvoPlanejamentoOficina: PublicoAlvoPlanejamentoOficina) {
        this.onAtualizarPublicoAlvoAtividade.emit(publicoAlvoPlanejamentoOficina);
    }

    novo() {
        this.onAdicionarPublicoAlvoPlanejamentoOficina.emit(true);
    }

    get descricaoFilter(): string {
        return this.descricaoFiltered;
    }

    set descricaoFilter(value: string) {
        this.descricaoFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    get dataFilter(): string {
        return this.dataFiltered;
    }

    set dataFilter(value: string) {
        this.dataFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    performFilter(): MatTableDataSource<PublicoAlvoPlanejamentoOficina> {
        let filteredRequestsX = this.dataSource.data.filter(
            (request: PublicoAlvoPlanejamentoOficina) => (!this.descricaoFiltered || request.descricao.includes(this.descricaoFiltered)) &&
                (!this.dataFiltered)
        );
        return !!this.descricaoFiltered || !!this.dataFiltered
            ? new MatTableDataSource(filteredRequestsX)
            : this.dataSource;
    }

}
